// extracted by mini-css-extract-plugin
export var completionBody = "_l8-2";
export var completionCard = "_l8-0";
export var completionFooter = "_l8-3";
export var completionTitle = "_l8-1";